export default "__VITE_ASSET__D6oZ56p$__";